import { render, staticRenderFns } from "./ShopCommissionTable.vue?vue&type=template&id=397f9118&scoped=true&"
import script from "./ShopCommissionTable.vue?vue&type=script&lang=js&"
export * from "./ShopCommissionTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopCommissionTable.vue?vue&type=style&index=0&id=397f9118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f9118",
  null
  
)

export default component.exports